import { CbhFeatureFlag } from "../../../FeatureFlags/CbhFeatureFlag";
import { useCbhFlag } from "../../../FeatureFlags/useCbhFlag";

export function useIsShiftBlocksEnabled() {
  const shiftBlockBookingFlag = useCbhFlag(CbhFeatureFlag.ROLLOUT_SHIFT_BLOCK_BOOKING, {
    defaultValue: {
      isBlockBookingEnabled: false,
    },
  });

  return shiftBlockBookingFlag.isBlockBookingEnabled;
}
